module.exports = __webpack_public_path__ + "static/media/drywall-interiors.21cf85ff.svg";